import { render } from "./collapse.vue?vue&type=template&id=992bf77a&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=992bf77a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-992bf77a"

export default script